export type metricCategory =  'compliance' | 'quality' | 'all';

export class Category{
    constructor(public id: string, public name: string){}
}

